const impersonateConfig = window?.["impersonateConfig"];
export const contextPath = window?.["contextPath"] ?? "";
export const impersonateSearchApi =
  impersonateConfig?.impersonateSearchApi ?? "";
export const impersonateUserSelectApi =
  impersonateConfig?.impersonateUserSelectApi ?? "";
export const impersonateUserResetApi =
  impersonateConfig?.impersonateUserResetApi ?? "";
